import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';
import { FarmingReviewFormData } from '../types/farmingReview';
import { PMT3WriteAPIResponse } from '../types/pmt3Types';

const farmingWriteFn = httpsCallable<
  { operation: string; data: any },
  PMT3WriteAPIResponse
>(functions, 'pmt3FarmingWrite');

class FarmingWriteService {
  private async callFunction(operation: string, data: any): Promise<PMT3WriteAPIResponse> {
    try {
      const result = await farmingWriteFn({ operation, data });
      return result.data;
    } catch (error: any) {
      console.error(`Farming write failed for ${operation}:`, error);
      throw error;
    }
  }

  async completeFarmingReview(
    formData: FarmingReviewFormData,
    spreadsheetId: string,
    currentASIN?: string,
    reviewerName?: string
  ): Promise<PMT3WriteAPIResponse> {
    return this.callFunction('completeFarmingReview', {
      spreadsheetId,
      currentASIN,
      reviewerName,
      bundleEntry: formData.bundleEntry,
      overrideEntry: formData.overrideEntry,
      cstOverride: formData.cstOverride,
      limitToMaxBid: formData.limitToMaxBid,
      newPpcStatus: formData.newPpcStatus,
      pauseFarming: formData.pauseFarming,
    });
  }

  async pasteFarmingNotes(
    notes: string,
    spreadsheetId: string,
    asinTabName?: string
  ): Promise<PMT3WriteAPIResponse> {
    return this.callFunction('pasteFarmingNotes', { notes, spreadsheetId, asinTabName });
  }

  async nextFarmingASIN(
    spreadsheetId: string,
    currentASIN?: string
  ): Promise<PMT3WriteAPIResponse> {
    return this.callFunction('nextFarmingASIN', { spreadsheetId, currentASIN });
  }

  validateFormClientSide(formData: FarmingReviewFormData): { isValid: boolean; errors: string[] } {
    const errors: string[] = [];
    if (!formData.bundleEntry.action.trim()) {
      errors.push('Bundle action/disposition is required');
    }
    return { isValid: errors.length === 0, errors };
  }
}

export const farmingWriteService = new FarmingWriteService();
export default farmingWriteService;
